import { VStack } from "@chakra-ui/react"
import React from "react"
import { GenerateUserRestrictedEntriesReportForm } from "../../../forms"

export const GenerateUserRestrictedEntriesReport: React.FC = () => {
	return (
		<VStack w="full" spacing={6}>
			<GenerateUserRestrictedEntriesReportForm />
		</VStack>
	)
}
